import type { CanMatchFn } from '@angular/router';

import { inject } from '@angular/core';
import { environment } from '@environment';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { Store } from '@ngrx/store';
import { isLogged } from '@wizbii-utils/angular/stores';
import { from, of, switchMap } from 'rxjs';
import { map, take } from 'rxjs/operators';

export const notLoggedGuard: CanMatchFn = () => {
  return inject(Store)
    .select(isLogged)
    .pipe(
      take(1),
      switchMap((isLogged) => {
        if (!isLogged) {
          return from(redirectToLogin()).pipe(map(() => false));
        }

        return of(true);
      })
    );
};

// wait redirection to resolve promise, avoiding a 404 blink before redirecting
const redirectToLogin = (): Promise<void> => {
  return new Promise((resolve) => {
    window.location.href = `${environment.urls.account.signUp}${window.location.origin}${environment.baseHref}${FeaturesRoutingEnum.HelpForm}`;

    window.addEventListener(
      'beforeunload',
      () => {
        resolve();
      },
      { once: true }
    );
  });
};
